module.exports = __webpack_public_path__ + "static/media/avatar.1a05fb23.png";